import { FC, useEffect, useState } from "react";
import { Col, FontBold, Row } from "../../../TrueUI";
import { rowWithNoMarginNorGutter } from "../../../TrueUI/Grids/Row";
import { EndorsementScheduleTableFooterUI } from "../EndorsementForm/EndorsementTypes";
import { formatNegativeNumbers } from "../../../../utilities/stringFunctions";
import { calculateTotalsForFooters } from "./EndorsementBindInstructionsUtils";
import { INSURED_ATOM_KEY } from "../../../../utilities/queryStringsHash";
import { useAtomFamily } from "../../../../hooks/useAtomFamily";
import { GlobalInsuredAtomFamily } from "../../InsuredAtoms";
import { useRecoilValue } from "recoil";
import { TriggerPolicyQuoteUpdateAtom } from "../hooks/usePolicyQuoteTriggerComponent";

type EndorsementScheduleTableFooterProps = {
  tabKey: string;
};

const EndorsementScheduleTableFooter: FC<
  EndorsementScheduleTableFooterProps
> = ({ tabKey }) => {
  const atomKey = `${INSURED_ATOM_KEY} ${tabKey}`;
  const { getAtom } = useAtomFamily(GlobalInsuredAtomFamily(atomKey));
  const [footerUI, setFooterUI] = useState<EndorsementScheduleTableFooterUI>();
  const listenerScheduleTableFooter = useRecoilValue(
    TriggerPolicyQuoteUpdateAtom("endorsementScheduleTableFooterComponent")
  );

  const updateFooterUIByRowsChanged = () => {
    const policyJSON = getAtom()?.policyQuoteInformation?.policyQuote;
    const newValuesForFooter = calculateTotalsForFooters(policyJSON?.invoices);
    setFooterUI(newValuesForFooter);
  };

  useEffect(() => {
    updateFooterUIByRowsChanged();
  }, [listenerScheduleTableFooter]);

  return (
    <Row {...rowWithNoMarginNorGutter} horizontalAlign="flex-end">
      <Col
        breakpoints={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}
        horizontalAlign="flex-start"
      >
        <FontBold>Total of all payments</FontBold>
      </Col>
      <Col
        breakpoints={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}
        horizontalAlign="flex-end"
      >
        <FontBold>
          {formatNegativeNumbers(footerUI?.totalInvoiceAmount ?? 0)}
        </FontBold>
      </Col>
      <Col
        breakpoints={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}
        horizontalAlign="flex-end"
      >
        <FontBold>
          {formatNegativeNumbers(footerUI?.totalEndorsement ?? 0)}
        </FontBold>
      </Col>
      <Col
        breakpoints={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}
        horizontalAlign="flex-end"
      >
        <FontBold>
          {formatNegativeNumbers(footerUI?.totalPaymentDue ?? 0)}
        </FontBold>
      </Col>
    </Row>
  );
};

export default EndorsementScheduleTableFooter;
